<div class="cancel-agreement">
  <div class="top_panel">
    <h3>Cancel Agreement</h3>
    <span (click)="close()" class="close">
      <img src="https://cdn.elitehw.com/images/cross.webp" />
    </span>
  </div>

  <div class="steeperprt">
    <mat-stepper [linear]="false" #stepper [selectedIndex]="stepIndex">
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel>Status</ng-template>
          <div class="refund_view">
            <div class="status_info">
              <div class="status_panel">
                <label> Monthly Premium </label>
                <p>
                  {{ details?.financialStats?.monthlyPremium || 0 | currency }}
                </p>
              </div>
              <div class="status_panel">
                <label> Months Used </label>
                <p>
                  {{ details?.financialStats?.monthsUsed || 0 | number }}
                </p>
              </div>
              <div class="status_panel">
                <label> Earned Premium </label>
                <p>
                  {{ details?.financialStats?.earnedPremium || 0 | currency }}
                </p>
              </div>
              <div class="status_panel">
                <label> Unearned Premium </label>
                <p>
                  {{ details?.financialStats?.unearnedPremium || 0 | currency }}
                </p>
              </div>
              <div class="status_panel">
                <label> Agreement Premium </label>
                <p>
                  {{ details?.financialStats?.agreementPremium || 0 | currency }}
                </p>
              </div>
              <div class="status_panel">
                <label> Paid Premium </label>
                <p>
                  {{ details?.financialStats?.paidPremium || 0 | currency }}
                </p>
              </div>
              <div class="status_panel">
                <label> Agreement Balance </label>
                <p>
                  {{ details?.financialStats?.agreementBalance || 0 | currency }}
                </p>
              </div>
              <div class="status_panel">
                <label> Net Unearned Premium </label>
                <p>
                  {{ details?.financialStats?.netUnearnedPremium || 0 | currency }}
                </p>
              </div>
              <div class="status_panel">
                <label> Net Refund </label>
                <p>
                  {{ details?.financialStats?.netRefund || 0 | currency }}
                </p>
              </div>
              <div class="status_panel">
                <label> Total Claims Paid </label>
                <p>
                  {{ details?.financialStats?.totalClaimsPaid || 0 | currency }}
                </p>
              </div>
            </div>

            <div class="refundprt" *ngIf="details?.financialStats?.refundAmount > 0">
              <div class="leftrefundprt">
                <label> Refund </label>
                <strong>
                  {{ details?.financialStats?.refundAmount || 0 | currency }}
                </strong>
              </div>
              <button class="btnconfirm" mat-button (click)="stepIndex = 1">Next</button>
            </div>
            <div class="refundprt cancel-agreement" *ngIf="details?.financialStats?.refundAmount <= 0">
                <div class="leftrefundprt">
                  <label> Refund </label>
                  <strong>
                    {{ details?.financialStats?.refundAmount || 0 | currency }}
                  </strong>
                </div>
                <button class="btnconfirm" mat-button (click)="cancelAgreement('agreementCancelRequest', true)" [disabled]="isLoading">Cancel Agreement</button>
              </div>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup" label="Confirm process">
        <form [formGroup]="secondFormGroup">
          <div class="btnpanel">
            <button class="back" mat-button (click)="stepIndex = 0" [disabled]="isLoading">Back</button>
            <button class="btnconfirm green" *ngIf="isUnsettled" mat-button (click)="voidTransaction()" [disabled]="isLoading">
              Process Void Transaction
            </button>

            <button class="btnconfirm green" mat-button *ngIf="!isUnsettled" (click)="cancelAgreement('agreementCancelRequest', false)" [disabled]="isLoading">
              Process Refund now
            </button>
            <button class="savelater" mat-button *ngIf="!isUnsettled && data?.isShowSaveForLaterButton" (click)="cancelAgreement('agreementCancelRequest', true)" [disabled]="isLoading">
              Save for Later
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Payment</ng-template>
        <div class="refund_process">
          <mat-tab-group (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Credit card">
              <form [formGroup]="cardDetailsForm">
                <div class="card_detail">
                  <div class="card_panel full">
                    <label> Card Holder Name </label>
                    <span>
                      <input
                        type="text"
                        placeholder="Card Holder Name"
                        formControlName="cardHoldarName"
                      />
                      <mat-error
                        *ngIf="
                          cardDetailsForm.controls['cardHoldarName'].touched &&
                          cardDetailsForm.controls['cardHoldarName'].hasError(
                            'required'
                          )
                        "
                      >
                        This is required
                      </mat-error>
                    </span>
                  </div>
                  <div class="card_panel full">
                    <label> Card Number </label>
                    <span>
                      <input
                        type="text"
                        placeholder="**** **** **** ****"
                        formControlName="cardNumber"
                        [hiddenInput]="true"
                        [mask]="
                          cardType == 'American Express'
                            ? 'XXXX XXXXXX X0000'
                            : 'XXXX XXXX XXXX 0000'
                        "
                        (ngModelChange)="detectCardType($event)"
                        [readOnly]="!bankandChequePaymentVisible"
                      />
                      <span
                        *ngIf="cardType && cardType == 'Visa'"
                        class="cardlogo"
                      >
                        <img
                          src="https://cdn.elitehw.com/images/visa-card-logo.png"
                          alt=""
                        />
                      </span>
                      <span
                        *ngIf="cardType && cardType == 'Mastercard'"
                        class="cardlogo mastercard"
                      >
                        <img
                          src="https://cdn.elitehw.com/images/master-card.png"
                          alt=""
                        />
                      </span>
                      <span
                        *ngIf="cardType && cardType == 'American Express'"
                        class="cardlogo"
                      >
                        <img
                          src="https://cdn.elitehw.com/images/American-Express.png"
                          alt=""
                        />
                      </span>
                      <span
                        *ngIf="cardType && cardType == 'Discover'"
                        class="cardlogo"
                      >
                        <img
                          src="https://cdn.elitehw.com/images/discover.png"
                          alt=""
                        />
                      </span>
                      <mat-error
                        *ngIf="
                          cardDetailsForm.controls['cardNumber'].touched &&
                          cardDetailsForm.controls['cardNumber'].hasError(
                            'required'
                          )
                        "
                      >
                        This is required
                      </mat-error>
                      <mat-error
                        *ngIf="
                          cardDetailsForm.controls['cardNumber'].touched &&
                          cardDetailsForm.controls['cardNumber'].hasError(
                            'mask'
                          )
                        "
                      >
                        Enter Valid Card Number
                      </mat-error>
                    </span>
                  </div>
                  <div class="card_panel">
                    <label> Expiration Date </label>
                    <span>
                      <input
                        type="text"
                        placeholder="00/00"
                        formControlName="monthYear"
                        mask="00/00"
                        [readOnly]="!bankandChequePaymentVisible"
                      />
                      <mat-error
                        *ngIf="
                          cardDetailsForm.controls['monthYear'].touched &&
                          cardDetailsForm.controls['monthYear'].hasError(
                            'required'
                          )
                        "
                      >
                        This is required
                      </mat-error>
                      <mat-error
                        *ngIf="
                          cardDetailsForm.controls['monthYear'].touched &&
                          cardDetailsForm.controls['monthYear'].hasError(
                            'mask'
                          ) &&
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'required'
                          )
                        "
                      >
                        Enter valid Expiry month and year.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'required'
                          ) &&
                          cardDetailsForm.controls['monthYear'].touched &&
                          cardDetailsForm.controls['expiryMonth'].hasError(
                            'max'
                          ) &&
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'mask'
                          ) &&
                          cardDetailsForm.controls['expiryYear'].valid
                        "
                      >
                        Enter Valid Expire Month.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'required'
                          ) &&
                          cardDetailsForm.controls['monthYear'].touched &&
                          cardDetailsForm.controls['expiryMonth'].hasError(
                            'min'
                          ) &&
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'mask'
                          )
                        "
                      >
                        Expiry Month value should be greater then 1.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'required'
                          ) &&
                          cardDetailsForm.controls['monthYear'].touched &&
                          cardDetailsForm.controls['expiryYear'].hasError(
                            'min'
                          ) &&
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'mask'
                          ) &&
                          cardDetailsForm.controls['expiryMonth'].valid
                        "
                      >
                        Enter Valid Expire Year.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'required'
                          ) &&
                          cardDetailsForm.controls['monthYear'].touched &&
                          cardDetailsForm.controls['expiryMonth'].hasError(
                            'max'
                          ) &&
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'mask'
                          ) &&
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'required'
                          ) &&
                          cardDetailsForm.controls['monthYear'].touched &&
                          cardDetailsForm.controls['expiryYear'].hasError(
                            'min'
                          ) &&
                          !cardDetailsForm.controls['monthYear'].hasError(
                            'mask'
                          )
                        "
                      >
                        Enter valid expire month and year.
                      </mat-error>
                      <mat-error *ngIf="
                      !cardDetailsForm.controls['monthYear'].hasError('required') && 
                      cardDetailsForm.controls['expiryMonth'].hasError('notValid') && 
                      !cardDetailsForm.controls['monthYear'].hasError('mask') &&
                      cardDetailsForm.controls['monthYear'].touched &&
                      !cardDetailsForm.controls['expiryYear'].hasError('min')">
                          Enter Valid Expire Month.
                    </mat-error>
                    </span>
                  </div>
                  <div class="card_panel">
                    <label> CVV </label>
                    <span>
                      <input
                        type="password"
                        placeholder="CVV"
                        formControlName="cvv"
                        [mask]="cardType == 'American Express' ? '0000' : '000'"
                        [readOnly]="!bankandChequePaymentVisible"
                      />
                      <mat-error
                        *ngIf="
                          cardDetailsForm.controls['cvv'].touched &&
                          cardDetailsForm.controls['cvv'].hasError('required')
                        "
                      >
                        This is required
                      </mat-error>
                      <mat-error
                        *ngIf="
                          cardDetailsForm.controls['cvv'].touched &&
                          cardDetailsForm.controls['cvv'].hasError('mask')
                        "
                      >
                        Enter valid cvv code.
                      </mat-error>
                    </span>
                  </div>
                  <div class="card_panel full">
                    <label> Transaction Number </label>
                    <span>
                      <input
                        type="text"
                        placeholder="Transaction Number"
                        formControlName="transactionNumber"
                      />
                      <mat-error
                        *ngIf="
                          cardDetailsForm.controls['transactionNumber']
                            .touched &&
                          cardDetailsForm.controls[
                            'transactionNumber'
                          ].hasError('required')
                        "
                      >
                        This is required
                      </mat-error>
                    </span>
                  </div>
                </div>
              </form>
            </mat-tab>
            <mat-tab label="Bank" *ngIf="bankandChequePaymentVisible">
              <form [formGroup]="bankDetailsForm">
                <div class="card_detail">
                  <div class="card_panel full">
                    <label> Account Holder Name </label>
                    <span>
                      <input
                        type="text"
                        placeholder="Account Holder Name"
                        formControlName="nameOnAccount"
                      />
                      <mat-error
                        *ngIf="
                          bankDetailsForm.controls['nameOnAccount'].touched &&
                          bankDetailsForm.controls['nameOnAccount'].hasError(
                            'required'
                          )
                        "
                      >
                        This is required
                      </mat-error>
                      <mat-error
                        *ngIf="
                          bankDetailsForm.controls['nameOnAccount'].touched &&
                          bankDetailsForm.controls['nameOnAccount'].hasError(
                            'minlength'
                          )
                        "
                      >
                        Name must be minimum 2 digits
                      </mat-error>
                    </span>
                  </div>
                  <div class="card_panel full">
                    <label> Account Number </label>
                    <span>
                      <input
                        type="text"
                        placeholder="**** **** **** ****"
                        mask="0000*"
                        minlength="4"
                        formControlName="accountNumber"
                      />
                      <mat-error
                        *ngIf="
                          bankDetailsForm.controls['accountNumber'].touched &&
                          bankDetailsForm.controls['accountNumber'].hasError(
                            'required'
                          )
                        "
                      >
                        This is required
                      </mat-error>
                      <mat-error
                        *ngIf="
                          bankDetailsForm.controls['accountNumber'].touched &&
                          bankDetailsForm.controls['accountNumber'].hasError(
                            'minlength'
                          )
                        "
                      >
                        Account Number must be minimum 4 digits.
                      </mat-error>
                    </span>
                  </div>
                  <div class="card_panel">
                    <label> Routing No </label>
                    <span>
                      <input
                        type="text"
                        placeholder="Routing No"
                        formControlName="routingNumber"
                        mask="000000000"
                        (ngModelChange)="getBankDetail()"
                      />
                      <mat-error
                        *ngIf="
                          bankDetailsForm.controls['routingNumber'].touched &&
                          bankDetailsForm.controls['routingNumber'].hasError(
                            'required'
                          )
                        "
                      >
                        This is required
                      </mat-error>
                      <mat-error
                        *ngIf="
                          bankDetailsForm.controls['routingNumber'].touched &&
                          (bankDetailsForm.controls['routingNumber'].hasError(
                            'minlength'
                          ) ||
                            bankDetailsForm.controls['routingNumber'].hasError(
                              'maxlength'
                            ))
                        "
                      >
                        Routing Number must be 9 digits.
                      </mat-error>
                    </span>
                  </div>
                  <div class="card_panel">
                    <label>Bank Name </label>
                    <span>
                      <input
                        type="text"
                        placeholder="Bank Name"
                        formControlName="bankName"
                        disabled
                      />
                      <mat-error
                        *ngIf="
                          bankDetailsForm.controls['bankName'].touched &&
                          bankDetailsForm.controls['bankName'].hasError(
                            'required'
                          )
                        "
                      >
                        This is required
                      </mat-error>
                    </span>
                  </div>
                  <div class="card_panel full">
                    <label> Transaction Number </label>
                    <span>
                      <input
                        type="text"
                        placeholder="Transaction Number"
                        formControlName="transactionNumber"
                      />
                      <mat-error
                        *ngIf="
                          bankDetailsForm.controls['transactionNumber']
                            .touched &&
                          bankDetailsForm.controls[
                            'transactionNumber'
                          ].hasError('required')
                        "
                      >
                        This is required
                      </mat-error>
                    </span>
                  </div>
                </div>
              </form>
            </mat-tab>
            <mat-tab label="Check" *ngIf="bankandChequePaymentVisible">
              <form [formGroup]="chequeDetailForm">
                <div class="card_detail">
                  <div class="card_panel full">
                    <label> Check Number </label>
                    <span>
                      <input
                        type="text"
                        placeholder="**** **** **** ****"
                        formControlName="checkNumber"
                        mask="0000*"
                      />
                      <mat-error
                        *ngIf="
                          chequeDetailForm.controls['checkNumber'].touched &&
                          chequeDetailForm.controls['checkNumber'].hasError(
                            'required'
                          )
                        "
                      >
                        This is required
                      </mat-error>
                      <mat-error
                        *ngIf="
                          chequeDetailForm.controls['checkNumber'].touched &&
                          chequeDetailForm.controls['checkNumber'].hasError(
                            'minlength'
                          )
                        "
                      >
                        Check Number must be minimum 4 digits.
                      </mat-error>
                    </span>
                  </div>
                </div>
              </form>
            </mat-tab>
          </mat-tab-group>
        </div>

        <div class="btnpanel">
          <button class="back" mat-button (click)="stepIndex = 1" [disabled]="isLoading">Back</button>
          <button class="btnconfirm green" mat-button (click)="checkPaymentDetails('agreementCancel')" [disabled]="isLoading">
            Submit
          </button>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
</div>
